export default __webpack_public_path__ + "static/media/Unsigned Contract Liberty.50dd73fd.png";